let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8MFe5")).then(() => parcelRequire('22eIY'));